
import { mapState } from 'vuex'
import { mdiClose } from '@mdi/js'

export default {
  name: 'CatalogFilterDrawer',
  components: {
    FilterExpansionPanels: () => import('@/components/catalog/FilterExpansionPanels')
  },
  data: () => ({
    mdiClose
  }),
  computed: {
    ...mapState('catalog', {}),

    drawer: {
      get () {
        return this.$store.state.catalog.filterDrawer
      },
      set (value) {
        this.$store.commit('catalog/setFilterDrawer', value)
      }
    }
  }
}
